import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import { CloseIcon } from 'shared/icons'

type ErrorDialogProps = {
  isOpen: boolean
  error: Error | null
  onClose: () => void
}
export const ErrorDialog = ({
  isOpen,
  error,
  onClose
}: ErrorDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between">
          <Typography component="p" variant="body1" fontSize="30px">
            Error
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography component="p" variant="body1" fontSize="20px" mt={3}>
          エラーが発生しました。
        </Typography>
        <Typography component="p" variant="body1" fontSize="20px" mt={3}>
          {error?.message}
        </Typography>
      </DialogContent>
    </Dialog>
  )
}
